import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Table from '../components/table/table';
import TableUserFilter from '../components/table/userFilter';
import ModalComponent from '../components/modal';

import {
  getAllUsers, activeUser, resendPassword, getCsvUsersReport, multiApprove,
} from '../app/store/actions/users';

import TRANSLATE from '../helpers/translate';

class AllUsersPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limit: 20,
      page: 1,
      search: '',
      type: '',
      status: '',
      showModal: false,
      selectedUser: null,
      message: '',
      success: '',
      orderBy: 'ASC',
      field: 'id',
    };
  }

  componentDidMount() {
    this.searchUsers();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.searchUsers();
  }

  searchUsers = async () => {
    const {
      search, page, limit, type, status, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;
    await this.props.searchItems(limit, skip, search, type, status, orderBy, field);
  }

  activeUser = async (userId, status) => {
    await this.props.activeUser(userId, status);
    await this.searchUsers();
  }

  multiApprove = async (usedId, multi) => {
    await this.props.multiApprove(usedId, multi);
    await this.searchUsers();
  }

  selectType = async (value) => {
    await this.setState({ type: value, page: 1 });
    await this.searchUsers();
  }

  selectStatus = async (value) => {
    await this.setState({ status: value, page: 1 });
    await this.searchUsers();
  }

  selectUser = async (row) => {
    await this.setState({
      selectedUser: row,
      showModal: true,
    });
  }

  closeModal = async () => {
    await this.setState({
      showModal: false,
      selectedUser: null,
      success: '',
      message: '',
    });
  }

  resendPassword = () => {
    const { selectedUser } = this.state;
    this.setState({ isLoading: true });
    try {
      this.props.resendPassword(selectedUser.id);
      this.setState({
        message: '',
        success: I18n.t('resendPasswordSuccess'),
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        message: I18n.t('errorOcurred'),
        success: '',
        isLoading: false,
      });
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.searchUsers();
  }

  render() {
    const {
      limit, page, type, status, showModal, selectedUser,
    } = this.state;
    const { users = {}, companyTag } = this.props;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'email', value: I18n.t('email') },
      { key: 'emitente', value: I18n.t('clients') },
      { key: 'name', value: I18n.t('name') },
      { key: 'role', value: I18n.t('type') },
      (companyTag === 'nortel' ? ({ key: 'multiApprove', value: 'Multi Aprovador' }) : {}),
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (users.rows || []).map((row, index) => ({
      key: index,
      id: row.id,
      email: row.email,
      emitente: row.emitente,
      name: row.name,
      role: TRANSLATE.userType(row.role),
      ...(companyTag === 'nortel') && {
        multiApprove: (
          <div className="row margin-left-0">
            <button
              type="button"
              className={`btn btn-${row.multiApprove ? 'warning' : 'dark'} promotion-btn-${row.multiApprove ? 'warning' : 'active'}`}
              onClick={() => this.multiApprove(row.id, !row.multiApprove)}
            >
              <Translate value={row.multiApprove ? 'disable' : 'active'} />
            </button>
          </div>
        ) || '',
      },
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${row.status === 'active' ? 'warning' : 'dark'} promotion-btn-${row.status === 'active' ? 'warning' : 'active'}`}
            onClick={() => this.activeUser(row.id, row.status === 'active' ? 'inactive' : 'active')}
          >
            <Translate value={row.status === 'active' ? 'disable' : 'active'} />
          </button>
        </div>
      ),
      action: (
        <div className="row margin-left-0">
          <button
            type="button"
            className="btn btn-dark"
            onClick={() => this.selectUser(row)}
          >
            {I18n.t('resendPassword')}
          </button>
        </div>
      ),
    }));

    const bodyModalRender = (
      <React.Fragment>
        <div className="form-main">
          <div className="form-group">
            <p className="change-password-title">{I18n.t('resendPassword')}</p>
            <span>
              {`${I18n.t('resendPasswordNotice')}  ${selectedUser && selectedUser.email}`}
            </span>
          </div>
          <button
            type="button"
            className="btn btn-dark"
            onClick={this.resendPassword}
            disabled={this.state.isLoading}
          >
            {I18n.t('resend')}
          </button>
          {this.state.success && <p className="color-green margin-top-10">{this.state.success}</p>}
          {this.state.message && <p className="color-red margin-top-10">{this.state.message}</p>}
        </div>
      </React.Fragment>
    );

    const tableButtons = (
      <React.Fragment>
        <button
          onClick={() => this.props.getCsvUsersReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">

        <ModalComponent
          visible={showModal}
          closeModal={this.closeModal}
          titleModal={false}
          bodyModal={bodyModalRender}
          titleOkButtoonModal={I18n.t('exit')}
          size={{ width: '300px', height: '150px' }}
          showCancel={false}
        />

        <Table
          title={I18n.t('users')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          extras={(
            <TableUserFilter
              type={type}
              status={status}
              selectType={this.selectType}
              selectStatus={this.selectStatus}
              isAllUsersPage
            />
          )}
          page={page}
          perPage={limit}
          count={users.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  searchItems: (limit, skip, search, type, status, order, field) => dispatch(
    getAllUsers(limit, skip, search, type, status, order, field),
  ),
  activeUser: (id, status) => dispatch(activeUser(id, status)),
  multiApprove: (id, multi) => dispatch(multiApprove(id, multi)),
  resendPassword: (userId) => dispatch(resendPassword(userId)),
  getCsvUsersReport: () => dispatch(getCsvUsersReport()),
});

const mapStateToProps = state => ({
  users: state.users.users,
  companyTag: state.settings && state.settings.companyTag,
});

export default connect(mapStateToProps, mapDispatchToProps)(AllUsersPage);
